import style from './EnterAmountPageSkeleton.css';
import Skeleton from '../../shared/Skeleton/Skeleton';

export default function EnterAmountPageSkeleton({ className = '' }) {
  return (
    <div className={`${className} ${style.container}`}>
      <div className={style.cards}>
        <div className={style.card}>
          <Skeleton className={style.title} radius={'81px'} width={'100%'} />
          <Skeleton
            className={style.description}
            radius={'81px'}
            width={'62%'}
          />
        </div>
        <div className={style.card}>
          <Skeleton
            className={style['card-title']}
            radius={'81px'}
            width={'100%'}
          />
          <Skeleton
            className={style['card-description']}
            radius={'81px'}
            width={'62%'}
          />
        </div>
      </div>
      <div className={style.content}>
        <Skeleton
          className={style.title}
          radius={'81px'}
          width={'80px'}
          height={'32px'}
        />
        <Skeleton
          className={style.description}
          radius={'81px'}
          width={'200px'}
          height={'12px'}
        />
      </div>
    </div>
  );
}
